import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {DocumentTypeModel} from '../shared/dto/document-type.model';
import {DocumentPage} from '../shared/dto/document-page';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class DocumentDetailsService {

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/document/';

  getAllDocumentType(id) {
    return this.http.get<any>(this.baseUrl + 'getDocumentDetailsById/' + id);
  }

  saveDocumentTypeAndDetails(details) {
    return this.http.post<any>(this.baseUrl + 'saveDocumentDetails', details);
  }

  getPages(docType: DocumentTypeModel) {
    return this.http.post<any>(this.baseUrl + 'getDocumentPages', docType);
  }

  getAllPages(docType: DocumentTypeModel) {
    return this.http.post<any>(this.baseUrl + 'getAllDocumentPages', docType);
  }

  getPagesById(id: number) {
    return this.http.get<any>(this.baseUrl + 'getDocumentPagesById/'+ id);
  }

  saveSidScan(saveObj: DocumentPage) {
    return this.http.post<any>(this.baseUrl + 'saveSidScan', saveObj);
  }
}
